import { Can } from "@casl/react";
import { ActionButton } from "@via/components/action-button/action-button.tsx";
import Drawer from "@via/components/drawer.tsx";
import { PageHeading } from "@via/components/page-heading.tsx";
import { DrawerSize } from "@via/components/table/table.tsx";
import { HorizontalTabs } from "@via/components/tabs.tsx";
import CreateWorkbenchForm from "@via/pages/workbenchs/create-workbench-form.tsx";
import {
  BUTTONS,
  PAGE_NAMES,
  ROUTES,
  WORKBENCH_TABS,
} from "@via/utils/constants.tsx";
import { type JSX, useEffect, useState } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { useAbility } from "@via/context/ability-context";
import { useUserConfigurations } from "@via/api/configuration";

export default function Workbenchs(): JSX.Element {
  const ability = useAbility([
    {
      action: "View",
      subject: "Button",
      condition: false,
    },
    {
      action: "View",
      subject: "Drawer",
      condition: false,
    },
  ]);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { data: configurations, isLoading: isConfigurationsLoading } =
    useUserConfigurations();
  const [open, setDrawerOpen] = useState(false);

  useEffect(() => {
    const newWorkbench = searchParams.get("new");
    if (newWorkbench) {
      setDrawerOpen(true);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!open) {
      searchParams.delete("new");
      navigate({
        pathname: ROUTES.AVAILABLE_WOKBENCH,
        search: searchParams.toString(),
      });
    }
  }, [open]);

  if (!isConfigurationsLoading && !configurations?.SHOW_WORKBENCH) {
    navigate("/404");
  }

  return (
    <main className="via-content-wrapper">
      <div className="via-page-heading-wrapper">
        <PageHeading title={PAGE_NAMES.WORKBENCH} />
        <Can I="View" a="Button" ability={ability}>
          <ActionButton
            button={BUTTONS.CREATE_WORKBENCH}
            primary={true}
            onClick={() => {
              setDrawerOpen(true);
            }}
          />
        </Can>
      </div>
      <Can I="View" a="Drawer" ability={ability}>
        <Drawer
          id="workbench-create"
          open={open}
          setOpen={setDrawerOpen}
          size={DrawerSize.Medium}>
          <CreateWorkbenchForm setOpen={setDrawerOpen} />
        </Drawer>
      </Can>
      <HorizontalTabs buttonIdPrefix="workbench" options={WORKBENCH_TABS} />
      <Outlet />
    </main>
  );
}
